import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useInjectScript } from './useInjectScript';
import { logError } from '../actions';

// https://developers.google.com/recaptcha/docs/v3
const RECAPTCHA_SRC = 'https://www.google.com/recaptcha/api.js'
  + `?render=${process.env.REACT_APP_RECAPTCHA_KEY}`;

const RECAPTCHA_SCRIPT_ID = 'reCAPTCHAv3';

export const useRecaptchaScript = () => {
  const dispatch = useDispatch();

  const onError = useCallback(() => {
    if (!window.grecaptcha) {
      dispatch(logError({
        action: 'useRecaptchaScript',
        description: 'Failed loading recaptcha',
      }));
    }
  }, [dispatch]);

  const scriptRecaptchaLoaded = useInjectScript({
    id: RECAPTCHA_SCRIPT_ID,
    onError,
    src: RECAPTCHA_SRC,
  });

  return scriptRecaptchaLoaded;
};
